import axios from "axios";

export const parseUrlToBlob = async (url: string) => {
  const response = await axios.get(url, {
    responseType: "blob",
  });

  return response.data;
};
